import React from "react";
import { BsBellFill } from "react-icons/bs";
import { BsChatFill } from "react-icons/bs";
import { BsPersonFill } from "react-icons/bs";
import { BsFillHouseFill } from "react-icons/bs";
import { useDimensions } from "../Util";
import { useNavigate } from "react-router-dom";


const TitleBar = () => {

    const navigate = useNavigate();

    const { w, h } = useDimensions();

    const titleBar = {
        width: 100 * w,
        height: 5 * h,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    }

    const iconContainer = {
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "middle",
        fontSize:w>h?"clamp(12px,15px,18px)":"clamp(12px,15px,18px)",
    }

    const icon = {
        marginInline:"7px"
    }

    const logoContainer = {
        fontSize:w>h?"clamp(15px,20px,25px)":"clamp(15px,20px,25px)",
        fontWeight:"900",
        marginLeft:"7px"
    }

    const logoPro = {
        color: "#00ADB5", 
        display: "inline", 
    }

    const logoAddictive = {
        color: "#EEEEEE", 
        display: "inline", 
    }

    const handleclick = (icon) => {
        navigate(icon)
    }

    return <div id="title-bar" style={titleBar}>
        <div id="logo-container" style={logoContainer}>
            <p id="logo-pro" style={logoPro}>PRO</p>
            <p id="logo-addictive" style={logoAddictive}>ADDICTIVE</p>
        </div>
        <div id="icon-container" style={iconContainer}>
            <BsFillHouseFill style={icon} onClick={() => handleclick("/")} />
            <BsBellFill style={icon} onClick={() => handleclick("/notifications")} />
            <BsChatFill style={icon} onClick={() => handleclick("/messages")} />
            <BsPersonFill style={icon} onClick={() => handleclick("/profile")} />
        </div>
    </div>
}

export default TitleBar;